function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M38 16.313C38 21.3036 31.1308 20.749 25.0879 20.749C14.7581 20.749 8 21.3036 8 16.313C8 14.5402 10.8844 11.9225 14.5429 13.2313C20.7838 3.41481 37.1392 9.14113 38 16.313Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2795 5.20466C14.2795 8.32919 11.0099 7.98196 8.13352 7.98196C3.21673 7.98196 0 8.32919 0 5.20466C0 4.09475 1.37294 2.4558 3.1143 3.27526C6.08485 -2.87072 13.8697 0.714448 14.2795 5.20466Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2795 5.20466C14.2795 8.32919 11.0099 7.98196 8.13352 7.98196C3.21673 7.98196 0 8.32919 0 5.20466C0 4.09475 1.37294 2.4558 3.1143 3.27526C6.08485 -2.87072 13.8697 0.714448 14.2795 5.20466Z",
  fill: "white"
});

function SvgClouds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 21,
    viewBox: "0 0 38 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/clouds.8bfeea49.svg";
export { ForwardRef as ReactComponent };